module.exports = __webpack_public_path__ + "img/light1.3f807149.jpg";